import {MapState, PlayerColor} from '@colonist/game-states'

export enum RoomType {
    Standard,
    FreeMap,
    BeginnerMode,
    CustomLink,
    DiscordActivity,
    Tournament,
}

export const TOURNAMENT_ROOM_KEYWORDS: string[] = ['event', 'tourney', 'ecl'] // Keep keyword length <= 8

export interface RoomPlayOrderSelectionData {
    mapState: MapState
    currentSelector: PlayerColor
    playOrder: [PlayerColor, number][]
}

export interface RoomSeedOrderSelectionData {
    seedOrder: [number, PlayerColor][]
}

export enum RoomCreationPhase {
    EditSettings,
    SeedOrderSelection,
    PlayOrderSelection,
}
